const safeIncludes = (a, b) => (a || '').includes(b)

const getFrames = (payload) => (payload.body.trace || {}).frames || []

// NOTE: The following is not working as browser don't have access to sourcemaps
export const isFromGlobalCode = (payload, path) => {
  const frames = getFrames(payload)
  const lastFrame = frames[frames.length - 1] || {}
  return (lastFrame.method === '[anonymous]' && lastFrame.filename === '<anonymous>') || // Chrome
    (lastFrame.method === 'global code' && !safeIncludes(lastFrame.filename, path)) || // Safari
    (lastFrame.method === '[anonymous]' && !safeIncludes(lastFrame.filename, path)) || // Firefox
    (safeIncludes(lastFrame.method, 'Global code') && lastFrame.filename === 'code') // IE
}

// NOTE: The following is not working as browser don't have access to sourcemaps
export const isFromExternalCode = (payload, path) => getFrames(payload).every(frame => !safeIncludes(frame.filename, path))

export const logErrorToRollbar = (...args) => {
  if (typeof window.onerror === 'function') {
    window.onerror(...args)
  }
}
